// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.StructureDetail-container {
  padding: 1rem;
  font-family: Arial, sans-serif;
}

.StructureDetail-title {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

.StructureDetail-header {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1rem;
  flex-wrap: wrap;
}

.StructureDetail-search {
  min-width: 450px;
  padding: 0.875rem 1rem 0.875rem 2.75rem;
  border: none;
  border-radius: 12px;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(10px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
}

.StructureDetail-addBtn {
    font-weight: 700;
    padding: 0.5rem 3rem;
    background-color: #d5421b;
    color: white;
    border: none;
    cursor: pointer;
    border-radius: 10px;
    font-size: 16px;
}
.StructureDetail-tableWrapper {
  overflow-x: auto;
}

.StructureDetail-table {
  width: 100%;
  border-collapse: collapse;
  min-width: 600px;
}

.StructureDetail-table th,
.StructureDetail-table td {
  border: 1px solid #ccc;
  padding: 0.75rem;
  text-align: left;
}

.StructureDetail-table th {
    background-color: #fadcc8;
    color: #e64a08;
}

@media (max-width: 768px) {
  .StructureDetail-header {
    flex-direction: column;
  }

  .StructureDetail-search {
    min-width: 100%;
    margin-bottom: 0.5rem;
  }

  .StructureDetail-addBtn {
    width: 100%;
  }
}

.structuredetails_edit_btn,
.structuredetails_delete_btn {
  padding: 6px 10px;
  margin: 0 4px;
  font-size: 0.85rem;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: 0.2s ease;
}

.structuredetails_edit_btn {
  background-color: #007bff;
  color: #fff;
}

.structuredetails_edit_btn:hover {
  background-color: #0056b3;
}

.structuredetails_delete_btn {
  background-color: #dc3545;
  color: #fff;
}

.structuredetails_delete_btn:hover {
  background-color: #a71d2a;
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .structuredetails_edit_btn,
  .structuredetails_delete_btn {
    display: block;
    width: 100%;
    margin: 4px 0;
    font-size: 0.9rem;
  }

  .StructureDetail-table th,
  .StructureDetail-table td {
    font-size: 0.85rem;
  }
}

.structuralPaymentAddform-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.structuralPaymentAddform-form {
  background: #fff;
  padding: 2rem;
  border-radius: 10px;
  width: 90%;
  max-width: 500px;
  position: relative;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.structuralPaymentAddform-closeBtn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.structuralPaymentAddform-title {
  margin-bottom: 1rem;
  font-size: 1.5rem;
  text-align: center;
}

.structuralPaymentAddform-field {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}

.structuralPaymentAddform-field label {
  margin-bottom: 0.5rem;
  font-weight: 600;
}

.structuralPaymentAddform-field input {
  padding: 0.5rem;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
}

.structuralPaymentAddform-submitBtn {
  width: 100%;
  padding: 0.75rem;
  background: #007bff;
  color: white;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  cursor: pointer;
}

.structuralPaymentAddform-submitBtn:hover {
  background: #0056b3;
}

/* Responsive tweaks */
@media (max-width: 480px) {
  .structuralPaymentAddform-form {
    padding: 1rem;
  }

  .structuralPaymentAddform-title {
    font-size: 1.25rem;
  }
}

.StructureDetail-table tfoot tr {
  background-color: #f8f8f8;
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/pages/structure/structuredetail.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uCAAuC;EACvC,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,qCAAqC;EACrC,2BAA2B;EAC3B,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,oBAAoB;IACpB,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,eAAe;AACnB;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,eAAe;IACf,qBAAqB;EACvB;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;;EAEE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,2BAA2B;AAC3B;EACE;;IAEE,cAAc;IACd,WAAW;IACX,aAAa;IACb,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;EACpB;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB","sourcesContent":[".StructureDetail-container {\n  padding: 1rem;\n  font-family: Arial, sans-serif;\n}\n\n.StructureDetail-title {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n.StructureDetail-header {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1rem;\n  flex-wrap: wrap;\n}\n\n.StructureDetail-search {\n  min-width: 450px;\n  padding: 0.875rem 1rem 0.875rem 2.75rem;\n  border: none;\n  border-radius: 12px;\n  font-size: 1rem;\n  background: rgba(255, 255, 255, 0.95);\n  backdrop-filter: blur(10px);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n  transition: all 0.3s ease;\n}\n\n.StructureDetail-addBtn {\n    font-weight: 700;\n    padding: 0.5rem 3rem;\n    background-color: #d5421b;\n    color: white;\n    border: none;\n    cursor: pointer;\n    border-radius: 10px;\n    font-size: 16px;\n}\n.StructureDetail-tableWrapper {\n  overflow-x: auto;\n}\n\n.StructureDetail-table {\n  width: 100%;\n  border-collapse: collapse;\n  min-width: 600px;\n}\n\n.StructureDetail-table th,\n.StructureDetail-table td {\n  border: 1px solid #ccc;\n  padding: 0.75rem;\n  text-align: left;\n}\n\n.StructureDetail-table th {\n    background-color: #fadcc8;\n    color: #e64a08;\n}\n\n@media (max-width: 768px) {\n  .StructureDetail-header {\n    flex-direction: column;\n  }\n\n  .StructureDetail-search {\n    min-width: 100%;\n    margin-bottom: 0.5rem;\n  }\n\n  .StructureDetail-addBtn {\n    width: 100%;\n  }\n}\n\n.structuredetails_edit_btn,\n.structuredetails_delete_btn {\n  padding: 6px 10px;\n  margin: 0 4px;\n  font-size: 0.85rem;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  transition: 0.2s ease;\n}\n\n.structuredetails_edit_btn {\n  background-color: #007bff;\n  color: #fff;\n}\n\n.structuredetails_edit_btn:hover {\n  background-color: #0056b3;\n}\n\n.structuredetails_delete_btn {\n  background-color: #dc3545;\n  color: #fff;\n}\n\n.structuredetails_delete_btn:hover {\n  background-color: #a71d2a;\n}\n\n/* Responsive adjustments */\n@media (max-width: 768px) {\n  .structuredetails_edit_btn,\n  .structuredetails_delete_btn {\n    display: block;\n    width: 100%;\n    margin: 4px 0;\n    font-size: 0.9rem;\n  }\n\n  .StructureDetail-table th,\n  .StructureDetail-table td {\n    font-size: 0.85rem;\n  }\n}\n\n.structuralPaymentAddform-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.6);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.structuralPaymentAddform-form {\n  background: #fff;\n  padding: 2rem;\n  border-radius: 10px;\n  width: 90%;\n  max-width: 500px;\n  position: relative;\n  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);\n}\n\n.structuralPaymentAddform-closeBtn {\n  position: absolute;\n  top: 10px;\n  right: 15px;\n  background: transparent;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n}\n\n.structuralPaymentAddform-title {\n  margin-bottom: 1rem;\n  font-size: 1.5rem;\n  text-align: center;\n}\n\n.structuralPaymentAddform-field {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-direction: column;\n}\n\n.structuralPaymentAddform-field label {\n  margin-bottom: 0.5rem;\n  font-weight: 600;\n}\n\n.structuralPaymentAddform-field input {\n  padding: 0.5rem;\n  border-radius: 6px;\n  border: 1px solid #ccc;\n  font-size: 1rem;\n}\n\n.structuralPaymentAddform-submitBtn {\n  width: 100%;\n  padding: 0.75rem;\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: 6px;\n  font-size: 1rem;\n  cursor: pointer;\n}\n\n.structuralPaymentAddform-submitBtn:hover {\n  background: #0056b3;\n}\n\n/* Responsive tweaks */\n@media (max-width: 480px) {\n  .structuralPaymentAddform-form {\n    padding: 1rem;\n  }\n\n  .structuralPaymentAddform-title {\n    font-size: 1.25rem;\n  }\n}\n\n.StructureDetail-table tfoot tr {\n  background-color: #f8f8f8;\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
